import React, { ReactNode } from 'react';
import LogoGrey from '@assets/icons/logo-grey.svg';

import './ErrorPage.scss';

interface ErrorPageProps {
    errorText?: string | ReactNode;
}

function ErrorPage({ errorText }: ErrorPageProps) {
    const defaultErrorText = 'This page doesn’t exist.';

    return (
        <div className="error-page">
            <div className="error-page__content">
                <div className="error-page__text">
                    {errorText || defaultErrorText}
                    <br />
                    For assistance, please contact our support team:
                    {` `}
                    <a href="mailto:voyage.support@wartsila.com">voyage.support@wartsila.com</a>
                    <div className="error-page__logo">
                        <img src={LogoGrey} alt="LogoGrey" />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ErrorPage;
